import React, { useEffect, useState } from "react";
import DynamicViewTable from "./DynamicViewTable";
import Popup from "reactjs-popup";
import print from "print-js";
import "./CrossingInward.css";
import {
    challanBiltyTableItems,
    challanBiltyTableHeader,
} from "../config/challanForm.js";
import { consignorBillingApiConfig } from "../config/apiConfig.js";
import {
    dataObject,
    validate,
    consignorBillingTableHeader,
    consignorBillingTableItems,
} from "../config/ConsignorBilling.js";
import FormColumn from "./FormColumn.js";
import { groupInfo, popupInfo } from "../config/ConsignorBilling.js";
import DatePicker from "react-datepicker";
import Autosuggest from "react-autosuggest";
import "./AutoSuggest.css";
import useForm from "./useForm";
import { SERVER_URL, USE_OVERLAY } from "../config/config";
import LoadingOverlay from "react-loading-overlay";
import ReportExcel from "./ReportExcel.js";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import { useLocation } from "react-router-dom";
import EditHistoryPopup from "./EditHistoryPopup.js";

const ConsignorBillingForm = ({ sessionObject }) => {
    const [mailStatus, setMailStatus] = useState("");
    const [updateStatus, setUpdateStatus] = useState("");
    const [isPodBilling, setIsPodBilling] =  useState(false);
    const location = useLocation();

    let variablesFromSession = {
        created_from: String(sessionObject.sessionVariables.branch_id),
        created_by: String(sessionObject.sessionVariables.user_id),
        company_id: sessionObject.sessionVariables.company_id ?? "1",
        fYear: sessionObject.sessionVariables.financial_year,
    };

    const useQuery = () => {
        return new URLSearchParams(useLocation().search);
      };
    let query = useQuery();


    useEffect(() => {

        const podBilling = query.get("pod_billing");
        console.log(podBilling);
        if(podBilling == 1) setIsPodBilling(true);
        else setIsPodBilling(false);

        const defaultConsignorBillNo = location.state ?? "";
        console.log(defaultConsignorBillNo);
        if(defaultConsignorBillNo != "") {
            myForm.setPageStateByField("bill_no", defaultConsignorBillNo);

            const fakeKey = { key: "Enter" }
            myForm.getPageOnKeyEnter(fakeKey, defaultConsignorBillNo);
        }

    }, []);

    const updateBiltyRate = async () => {
        myForm.setOverlay(true);

        const url = SERVER_URL + "/bilty/update_rate";
        const dataToSend = {
            date_from: new Date(myForm.pageState.update_date_from).toISOString(),
            date_to: new Date(myForm.pageState.update_date_to).toISOString(),
            consignor_id: parseInt(myForm.pageState.consignor_id),
            bill_id: parseInt(myForm.pageState.id),
            station_from: parseInt(myForm.pageState.created_from),
        };

        let resp = await fetch(url, { 
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            method: "POST",
            body: JSON.stringify(dataToSend),
        })

        if(resp.ok) {
            const details = await resp.json();
            if("flag" in details && details.flag == "1") {
                setUpdateStatus("Updation Successful!");
            }
            else {
                setUpdateStatus(details.detail);
            }
        }
        else {
            setUpdateStatus("Something went wrong, Could not update.")
        }
        myForm.setOverlay(false);
    }

    const myForm = useForm(
        "CONSIGNORBILLING",
        validate,
        { ...dataObject, ...variablesFromSession },
        consignorBillingApiConfig
    );

    const handlePrint = async () => {
        let url = SERVER_URL + "/tbb_billing_statement/print/";

        let apiInputData = {
            ...myForm.pageState,
            fyear: myForm.pageState.fYear_get,
            companyId: myForm.pageState.company_id,
        }

        let response = await fetch(url, {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            method: "POST",
            body: JSON.stringify(apiInputData),
        }).then((r) => r.blob());
        console.log("response", response);
        print({ printable: URL.createObjectURL(response), type: "pdf", showModal: false });
    }

    const download_ref = React.useRef(null);

    const contentStyle = {
        maxWidth: "600px",
        width: "90%",
    };

    const transporterFieldInfo = {
        label: "Consignor Name",
        className: "form-row",
        labelClassName: "form-label",
        inputClassName: "form-input",
        name: "consignor_name",
        type: "text",
        placeHolder: "",
        apiConfigKey: "getConsignorSuggestions",
        url: SERVER_URL + "/consignor/",
        suggestionKeyword: "consignor_name",
        suggestionKeywordExtra: "consignor_gst",
        suggestionKeywordForFetchApiArgs: "name",
        suggestionChooseQueryKeyword: "consignor_id",
        suggestionSchema: {
            consignor_name: "consignor_name",
            consignor_gst: "consignor_gst",
            consignor_id: "consignor_id",
        },
        apiCallRequiredOnGetValue: true,
        toValidate: true,
        regExpValidation: "[a-zA-z]",
        keyboardNavigationMap: {
            Enter: "remarks",
        },
        idClearanceNeeded: "consignor_id",
        inputDataNeededInSuggestions: false,
        inputDataFilter: {
            pay_type: "same",
        },
    };

    const tirupatiVehicleFieldInfo = {
        label: "Vehicle No.",
        className: "form-row",
        labelClassName: "form-label",
        inputClassName: "form-input",
        name: "vehicle_no",
        type: "text",
        placeHolder: "",
        apiConfigKey: "getVehicleSuggestions",
        url: SERVER_URL + "/vehicle/",
        suggestionKeyword: "vehicle_no",
        suggestionKeywordForFetchApiArgs: "vehicle_no",
        suggestionChooseQueryKeyword: "vehicle_no",
        suggestionSchema: {
            vehicle_id: "vehicle_id",
            vehicle_no: "vehicle_no",
        },
        apiCallRequiredOnGetValue: true,
        toValidate: false,
        keyboardNavigationMap: {
            Enter: "bill_date",
        },
    };



    const linkBilty = async (e) => {
        if (e.target.value == "" && e.key == "Enter") {
            myForm.makeFocusOnParticularField("remarks");
            return;
        }
        if (e.key == "Enter") {
            // TODO: hit api here, changes for bilty_info
            const fYear_fetch = JSON.parse(sessionStorage.getItem("financial_year_for_fetch")).financial_year_for_fetch;
            const isTirupatiClient = ["TRL", "ttw", "te"].includes(process.env.REACT_APP_CLIENT);
            const isVehicleTrigger = e.target.name === "vehicle_no";
            let url = "";
            let payload = {};

            if (isTirupatiClient && isVehicleTrigger) {
                url = `${SERVER_URL}/bilty/tbb_billing_vehicle/`;
                payload = {
                    date_to: myForm.pageState.input_date,
                    amount: myForm.pageState.amount,
                    vehicle_no: myForm.pageState.vehicle_no,
                    id: myForm.pageState.id,
                    fyear: fYear_fetch,
                    companyId: myForm.pageState.company_id,
                };

                if ("vehicle_no" in myForm.refStoreObject.current) {
                    myForm.refStoreObject.current.vehicle_no.blur();
                }
            } else {
                const temp = (isPodBilling) ? "pod_billing" : "tbb_billing_party";
                url = SERVER_URL + `/bilty/${temp}/`;
                payload = {
                    date_to: myForm.pageState.input_date,
                    amount: myForm.pageState.amount,
                    consignor_id: myForm.pageState.consignor_id,
                    id: myForm.pageState.id,
                    fyear: fYear_fetch,
                    companyId: myForm.pageState.company_id,
                };

                if ("consignor_name" in myForm.refStoreObject.current) {
                    myForm.refStoreObject.current.consignor_name.blur();
                }
            }

            myForm.setOverlay(true);
            let response = await fetch(url, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            });
            if (!response.ok) {
                myForm.setPageState({
                    ...myForm.pageState,
                    ["Bilty No"]: "Invalid Bilty",
                });
                myForm.setOverlay(false);
                return;
            }
            const temp_response = await response.json();
            console.log("Temp response", temp_response);
            if (temp_response.check_fail) {
                myForm.setPageState({
                    ...myForm.pageState,
                    ["Bilty No"]: "Not possible to add this bilty",
                });
                myForm.setOverlay(false);
                return;
            }
            myForm.setOverlay(false);
            let partyName = "";
            let total_amount = 0;
            let newState = {
                bilty_ids: temp_response,
            };
            let tran_freight = 0;
            let our_freight = 0;
            let to_pay = 0;
            let paid = 0;
            let pkgs = 0;
            let bilty_charge = 0;
            let lc_charge = 0;
            let extra_hamali = 0;
            let dd_charge = 0;
            let charge_hamali = 0;
            let charge_rto = 0;
            let rto = 0;
            let advance = 0;
            let charge_detention = 0;
            let loading_charge = 0;
            let unloading_charge = 0;
            let bilty_detention = 0;
            let detention = 0;
            let other_charge = 0;
            let other_amount = 0;
            let biltyObj = {};
            for (let i = 0; i < newState.bilty_ids.length; i++) {
                newState.bilty_ids[i].checked = "1";
                biltyObj = newState.bilty_ids[i];
                tran_freight += parseFloat(biltyObj.transporter_freight) || 0;
                our_freight += parseFloat(biltyObj.freight) || 0;
                bilty_charge += parseFloat(biltyObj.bilty_charge) || 0;
                lc_charge += parseFloat(biltyObj.lc_charge) || 0;
                dd_charge += parseFloat(biltyObj.door_del_charge) || 0;
                if (process.env.REACT_APP_CLIENT !== "mk_log") {
                    extra_hamali += parseFloat(biltyObj.hamali) || 0;
                }
                if (["mimansha", "rtc", "bl", "mk_log", "TRL", "ttw", "te"].includes(process.env.REACT_APP_CLIENT)) {
                    charge_hamali += parseFloat(biltyObj.hamali) || 0;
                } else {
                    charge_hamali += parseFloat(biltyObj.hamali_charge) || 0;
                }
                charge_rto += parseFloat(biltyObj.rto_charge) || 0;
                rto += parseFloat(biltyObj.rto) || 0;
                advance += parseFloat(biltyObj.advance) || 0;
                charge_detention += parseFloat(biltyObj.detention_charge) || 0;
                detention += parseFloat(biltyObj.detention) || 0;
                loading_charge += parseFloat(biltyObj.loading_charge) || 0;
                unloading_charge += parseFloat(biltyObj.unloading_charge) || 0;
                bilty_detention += parseFloat(biltyObj.bilty_detention) || 0;
                other_amount += parseFloat(biltyObj.other_amount) || 0;
                if (biltyObj.pay_type == "1") {
                    to_pay += parseFloat(biltyObj.transporter_freight) || 0;
                } else {
                    paid += parseFloat(biltyObj.transporter_freight) || 0;
                }
                if(biltyObj.pay_type == "1" || biltyObj.pay_type == "2"){
                    other_charge += parseFloat(biltyObj.other_amount) || 0;
                }
                pkgs += parseFloat(biltyObj.no_of_package) || 0;
            }
            //   newState.transporter_freight = String(tran_freight);
            if (process.env.REACT_APP_CLIENT === "mk_log") {
                total_amount = our_freight + detention + charge_rto + charge_hamali;
            }
            else if (["atc", "mimansha", "rtc", "bl", "TRL", "ttw", "te"].includes(process.env.REACT_APP_CLIENT)) {
                total_amount = our_freight + charge_detention + charge_rto + charge_hamali;
            }
            else {
                total_amount =
                    our_freight +
                    bilty_charge +
                    dd_charge +
                    extra_hamali +
                    other_charge +
                    lc_charge +
                    rto -
                    advance +
                    loading_charge +
                    unloading_charge +
                    bilty_detention +
                    other_amount;
            }

            newState.gross_amount = String(parseInt(our_freight));
            newState.bilty_charge = String(bilty_charge);
            newState.lc_charge = String(lc_charge);
            newState.door_del_charge = String(dd_charge);
            newState.extra_hamali = String(extra_hamali);
            newState.hamali_charge = String(charge_hamali);
            newState.rto_charge = String(charge_rto);
            newState.rto = String(rto);
            newState.advance = String(advance);
            newState.detention_charge = String(charge_detention);
            newState.detention = String(detention);
            newState.loading_charge = String(loading_charge);
            newState.unloading_charge = String(unloading_charge);
            newState.bilty_detention = String(bilty_detention);
            newState.total_amount = String(parseInt(total_amount));
            const pay0 = parseFloat(myForm.pageState.payment_0) || 0;
            const pay1 = parseFloat(myForm.pageState.payment_1) || 0;
            newState.net_amount = String(parseInt(total_amount) - pay0 - pay1);

            if (["mimansha", "rtc", "bl", "mk_log", "TRL", "ttw", "te"].includes(process.env.REACT_APP_CLIENT)) {
                newState.other_amount = String(other_amount);
            }
            console.log("GROSSSSSSSSSSSSSS",parseInt(our_freight),other_charge,total_amount)
            // if(process.env.REACT_APP_CLIENT == "xpress"){
            //     let temp = 0;
            //     for (let i = 0; i < temp_response.length; i++) {
            //         temp += parseInt(temp_response[i].total_amount);
            //     }
            //         newState.total_amount = temp
            //     console.log("Jauuuuuuuuuu",temp,myForm.pageState)
            // }
            //   newState.pkgs = String(pkgs);
            //   newState.to_pay = String(to_pay);
            //   newState.paid = String(paid);
            //   newState.balance = String(our_freight - to_pay);

            // TODO: set fyear? if not setting automatically
            console.log("New state", newState);
            myForm.setPageState((prevState) => ({
                ...prevState,
                ...newState,
            }));
            myForm.makeFocusOnParticularField("bill_date");
        }
    };

    const handleDelete = async () => {
        const url =
            SERVER_URL +
            "/tbb_billing_statement/?tbb_statement_id=" +
            myForm.pageState.id
            + "&fyear=" + myForm.pageState.fYear_get;
        const response = await fetch(url, { method: "DELETE" });
        if (!response.ok) {
            console.log("Not able to delete Bill");
            return;
        }
        const temp_response = await response.json();
        if (temp_response.is_deleted) {
            myForm.setPageState({ ...dataObject, ...variablesFromSession });
            myForm.setPageMode("write");
            window.location.reload();
            return;
        }
    };

    const handleCheckboxChange = (arr, item, idx) => {
        console.log("item", item);
        console.log("arrr", arr.target, arr.target.checked);
        let dummyArray = myForm.pageState.bilty_ids;
        console.log("bilty ids dummy", dummyArray);
        if (arr.target.checked) {
            dummyArray[idx].checked = "1";
        } else {
            dummyArray[idx].checked = "0";
        }
        let newState = {
            bilty_ids: dummyArray,
        };
        let total_amount = 0;
        let tran_freight = 0;
        let our_freight = 0;
        let to_pay = 0;
        let paid = 0;
        let pkgs = 0;
        let bilty_charge = 0;
        let extra_hamali = 0;
        let dd_charge = 0;
        let charge_hamali = 0;
        let charge_rto = 0;
        let rto = 0;
        let advance = 0;
        let loading_charge = 0;
        let unloading_charge = 0;
        let bilty_detention = 0;
        let charge_detention = 0;
        let other_charge = 0;
        let lc_charge = 0;
        let other_amount = 0;
        let detention = 0;
        
        let biltyObj = {};
        for (let i = 0; i < newState.bilty_ids.length; i++) {
            if (newState.bilty_ids[i].checked == "0") {
                continue;
            }
            biltyObj = newState.bilty_ids[i];
            tran_freight += parseFloat(biltyObj.transporter_freight) || 0;
            our_freight += parseFloat(biltyObj.freight) || 0;
            bilty_charge += parseFloat(biltyObj.bilty_charge) || 0;
            dd_charge += parseFloat(biltyObj.door_del_charge) || 0;
            if (process.env.REACT_APP_CLIENT !== "mk_log") {
                extra_hamali += parseFloat(biltyObj.hamali) || 0;
            }
            if (["mimansha", "rtc", "bl", "mk_log", "TRL", "ttw", "te"].includes(process.env.REACT_APP_CLIENT)) {
                charge_hamali += parseFloat(biltyObj.hamali) || 0;
            } else {
                charge_hamali += parseFloat(biltyObj.hamali_charge) || 0;
            }
            charge_rto += parseFloat(biltyObj.rto_charge) || 0;
            rto += parseFloat(biltyObj.rto) || 0;
            advance += parseFloat(biltyObj.advance) || 0;
            loading_charge += parseFloat(biltyObj.loading_charge) || 0;
            unloading_charge += parseFloat(biltyObj.unloading_charge) || 0;
            bilty_detention += parseFloat(biltyObj.bilty_detention) || 0;
            charge_detention += parseFloat(biltyObj.detention_charge) || 0;
            detention += parseFloat(biltyObj.detention) || 0;
            other_amount += parseFloat(biltyObj.other_amount) || 0;
            lc_charge += parseFloat(biltyObj.lc_charge) || 0;

            if (biltyObj.pay_type == "1") {
                to_pay += parseFloat(biltyObj.transporter_freight) || 0;
            } else {
                paid += parseFloat(biltyObj.transporter_freight) || 0;
            }
            if(biltyObj.pay_type == "1" || biltyObj.pay_type == "2"){
                other_charge += parseFloat(biltyObj.other_amount) || 0;
            }
            pkgs += parseFloat(biltyObj.no_of_package) || 0;
        }
        //   newState.transporter_freight = String(tran_freight);
        if (process.env.REACT_APP_CLIENT === "mk_log") {
            total_amount = our_freight + detention + charge_rto + charge_hamali;
        }
        else if (["atc", "mimansha", "rtc", "bl", "TRL", "ttw", "te"].includes(process.env.REACT_APP_CLIENT)) {
            total_amount = our_freight + charge_detention + charge_rto + charge_hamali;
        }
        else {
            total_amount =
                our_freight +
                bilty_charge +
                dd_charge +
                extra_hamali +
                other_charge +
                lc_charge +
                rto -
                advance +
                loading_charge +
                unloading_charge +
                bilty_detention +
                other_amount;
        }
                      
        newState.gross_amount = String(parseInt(our_freight));
        newState.bilty_charge = String(bilty_charge);
        newState.door_del_charge = String(dd_charge);
        newState.extra_hamali = String(extra_hamali);
        newState.hamali_charge = String(charge_hamali);
        newState.rto_charge = String(charge_rto);
        newState.rto = String(rto);
        newState.advance = String(advance);
        newState.loading_charge = String(loading_charge);
        newState.unloading_charge = String(unloading_charge);
        newState.bilty_detention = String(bilty_detention);
        newState.detention = String(detention);
        newState.detention_charge = String(charge_detention);
        newState.total_amount = String(parseInt(total_amount));
        const pay0 = parseFloat(myForm.pageState.payment_0) || 0;
        const pay1 = parseFloat(myForm.pageState.payment_1) || 0;
        newState.net_amount = String(parseInt(total_amount) - pay0 - pay1); 
        newState.other_amount = String(parseInt(other_amount));
        newState.lc_charge = String(parseInt(lc_charge));
        // if(process.env.REACT_APP_CLIENT == "xpress"){
        //     let total_amount = 0;
        //     let our_freight = 0;
        //     for (let i = 0; i < newState.bilty_ids.length; i++) {
        //         const biltyObj = newState.bilty_ids[i];
        //         if (biltyObj.checked == "1") {
        //             our_freight += parseFloat(biltyObj.total_amount) || 0;
        //         }
        //     }
        //     total_amount = our_freight;
        //     newState.total_amount = total_amount;
        // }
        // myForm.setPageStateByField("bilty_ids", dummyArray)
        myForm.setPageState((prevState) => ({
            ...prevState,
            ...newState,
        }));
    };

    const selectAll = () => {
        let dummyArray = myForm.pageState.bilty_ids;
        for (let i = 0; i < dummyArray.length; i++) {
            dummyArray[i].checked = "1";
        }
        let newState = {
            bilty_ids: dummyArray,
        };
        let total_amount = 0;
        let tran_freight = 0;
        let our_freight = 0;
        let to_pay = 0;
        let paid = 0;
        let pkgs = 0;
        let bilty_charge = 0;
        let extra_hamali = 0;
        let dd_charge = 0;
        let charge_hamali = 0;
        let charge_rto = 0;
        let rto = 0;
        let advance = 0;
        let loading_charge = 0;
        let unloading_charge = 0;
        let bilty_detention = 0;
        let charge_detention = 0;
        let other_charge = 0;
        let other_amount = 0;
        let lc_charge = 0;
        let detention = 0;

        let biltyObj = {};
        for (let i = 0; i < newState.bilty_ids.length; i++) {
            if (newState.bilty_ids[i].checked == "0") {
                continue;
            }
            biltyObj = newState.bilty_ids[i];
            tran_freight += parseFloat(biltyObj.transporter_freight) || 0;
            our_freight += parseFloat(biltyObj.freight) || 0;
            bilty_charge += parseFloat(biltyObj.bilty_charge) || 0;
            dd_charge += parseFloat(biltyObj.door_del_charge) || 0;
            if (process.env.REACT_APP_CLIENT !== "mk_log") {
                extra_hamali += parseFloat(biltyObj.hamali) || 0;
            }
            if (["mimansha", "rtc", "mk_log", "bl", "TRL", "ttw", "te"].includes(process.env.REACT_APP_CLIENT)) {
                charge_hamali += parseFloat(biltyObj.hamali) || 0;
            } else {
                charge_hamali += parseFloat(biltyObj.hamali_charge) || 0;
            }
            charge_rto += parseFloat(biltyObj.rto_charge) || 0;
            rto += parseFloat(biltyObj.rto) || 0;
            advance += parseFloat(biltyObj.advance) || 0;
            loading_charge += parseFloat(biltyObj.loading_charge) || 0;
            unloading_charge += parseFloat(biltyObj.unloading_charge) || 0;
            bilty_detention += parseFloat(biltyObj.bilty_detention) || 0;
            detention += parseFloat(biltyObj.detention) || 0;
            charge_detention += parseFloat(biltyObj.detention_charge) || 0;
            other_amount += parseFloat(biltyObj.other_amount) || 0;
            lc_charge += parseFloat(biltyObj.lc_charge) || 0;

            if (biltyObj.pay_type == "1") {
                to_pay += parseFloat(biltyObj.transporter_freight) || 0;
            } else {
                paid += parseFloat(biltyObj.transporter_freight) || 0;
            }
            if(biltyObj.pay_type == "1" || biltyObj.pay_type == "2"){
                other_charge += parseFloat(biltyObj.other_amount) || 0;
            }
            pkgs += parseFloat(biltyObj.no_of_package) || 0;
        }
        //   newState.transporter_freight = String(tran_freight);
        if (process.env.REACT_APP_CLIENT === "mk_log") {
            total_amount = our_freight + detention + charge_rto + charge_hamali;
        }
        else if (["atc", "mimansha", "rtc", "bl", "TRL", "ttw", "te"].includes(process.env.REACT_APP_CLIENT)) {
            total_amount = our_freight + charge_detention + charge_rto + charge_hamali;
        }
        else {
            total_amount =
                our_freight +
                bilty_charge +
                dd_charge +
                extra_hamali +
                other_charge +
                lc_charge +
                rto -
                advance +
                loading_charge +
                unloading_charge +
                bilty_detention +
                other_amount;
        }

        newState.gross_amount = String(parseInt(our_freight));
        newState.bilty_charge = String(bilty_charge);
        newState.door_del_charge = String(dd_charge);
        newState.extra_hamali = String(extra_hamali);
        newState.hamali_charge = String(charge_hamali);
        newState.rto_charge = String(charge_rto);
        newState.rto = String(rto);
        newState.advance = String(advance);
        newState.loading_charge = String(loading_charge);
        newState.unloading_charge = String(unloading_charge);
        newState.bilty_detention = String(bilty_detention);
        newState.detention = String(detention);
        newState.detention_charge = String(charge_detention);
        newState.total_amount = String(parseInt(total_amount));
        const pay0 = parseFloat(myForm.pageState.payment_0) || 0;
        const pay1 = parseFloat(myForm.pageState.payment_1) || 0;
        newState.net_amount = String(parseInt(total_amount) - pay0 - pay1); 
        newState.other_amount = String(parseInt(other_amount));
        newState.lc_charge = String(parseInt(lc_charge));
        // if(process.env.REACT_APP_CLIENT == "xpress"){
        //     let total_amount = 0;
        //     let our_freight = 0;
        //     for (let i = 0; i < newState.bilty_ids.length; i++) {
        //         const biltyObj = newState.bilty_ids[i];
        //         if (biltyObj.checked == "1") {
        //             our_freight += parseFloat(biltyObj.total_amount) || 0;
        //         }
        //     }
        //     total_amount = our_freight;
        //     newState.total_amount = total_amount;
        // }
        // myForm.setPageStateByField("bilty_ids", dummyArray)
        myForm.setPageState((prevState) => ({
            ...prevState,
            ...newState,
        }));
    };

    const deselectAll = () => {
        let dummyArray = myForm.pageState.bilty_ids;
        for (let i = 0; i < dummyArray.length; i++) {
            dummyArray[i].checked = "0";
        }
        let newState = {
            bilty_ids: dummyArray,
        };
        let total_amount = 0;
        let tran_freight = 0;
        let our_freight = 0;
        let to_pay = 0;
        let paid = 0;
        let pkgs = 0;
        let bilty_charge = 0;
        let extra_hamali = 0;
        let dd_charge = 0;
        let charge_hamali = 0;
        let charge_rto = 0;
        let rto = 0;
        let advance = 0;
        let loading_charge = 0;
        let unloading_charge = 0;
        let bilty_detention = 0;
        let charge_detention = 0;
        let other_amount = 0;
        let lc_charge = 0;
        let detention = 0;

        let biltyObj = {};
        for (let i = 0; i < newState.bilty_ids.length; i++) {
            if (newState.bilty_ids[i].checked == "0") {
                continue;
            }
            biltyObj = newState.bilty_ids[i];
            tran_freight += parseFloat(biltyObj.transporter_freight) || 0;
            our_freight += parseFloat(biltyObj.freight) || 0;
            bilty_charge += parseFloat(biltyObj.bilty_charge) || 0;
            dd_charge += parseFloat(biltyObj.door_del_charge) || 0;
            if (process.env.REACT_APP_CLIENT !== "mk_log") {
                extra_hamali += parseFloat(biltyObj.hamali) || 0;
            }
            if (["mimansha", "rtc","mk_log", "bl", "TRL", "ttw", "te"].includes(process.env.REACT_APP_CLIENT)) {
                charge_hamali += parseFloat(biltyObj.hamali) || 0;
            } else {
                charge_hamali += parseFloat(biltyObj.hamali_charge) || 0;
            }
            charge_rto += parseFloat(biltyObj.rto_charge) || 0;
            advance += parseFloat(biltyObj.advance) || 0;
            rto += parseFloat(biltyObj.rto) || 0;
            loading_charge += parseFloat(biltyObj.loading_charge) || 0;
            unloading_charge += parseFloat(biltyObj.unloading_charge) || 0;
            bilty_detention += parseFloat(biltyObj.bilty_detention) || 0;
            detention += parseFloat(biltyObj.detention) || 0;
            charge_detention += parseFloat(biltyObj.detention_charge) || 0;
            other_amount += parseFloat(biltyObj.other_amount) || 0;
            lc_charge += parseFloat(biltyObj.lc_charge) || 0;

            if (biltyObj.pay_type == "1") {
                to_pay += parseFloat(biltyObj.transporter_freight) || 0;
            } else {
                paid += parseFloat(biltyObj.transporter_freight) || 0;
            }
            pkgs += parseFloat(biltyObj.no_of_package) || 0;
        }
        //   newState.transporter_freight = String(tran_freight);
        if (process.env.REACT_APP_CLIENT === "mk_log") {
            total_amount = our_freight + detention + charge_rto + charge_hamali;
        }
        else if (["atc", "mimansha", "rtc", "bl", "TRL", "ttw", "te"].includes(process.env.REACT_APP_CLIENT)) {
            total_amount = our_freight + charge_detention + charge_rto + charge_hamali;
        }
        else {
            total_amount =
                our_freight +
                bilty_charge +
                dd_charge +
                extra_hamali +
                other_charge +
                lc_charge +
                rto -
                advance +
                loading_charge +
                unloading_charge +
                bilty_detention +
                other_amount;
        }

        newState.gross_amount = String(parseInt(our_freight));
        newState.bilty_charge = String(bilty_charge);
        newState.door_del_charge = String(dd_charge);
        newState.extra_hamali = String(extra_hamali);
        newState.hamali_charge = String(charge_hamali);
        newState.rto_charge = String(charge_rto);
        newState.rto = String(rto);
        newState.advance = String(advance);
        newState.loading_charge = String(loading_charge);
        newState.unloading_charge = String(unloading_charge);
        newState.detention = String(detention);
        newState.bilty_detention = String(bilty_detention);
        newState.detention_charge = String(charge_detention);
        newState.total_amount = String(parseInt(total_amount));
        const pay0 = parseFloat(myForm.pageState.payment_0) || 0;
        const pay1 = parseFloat(myForm.pageState.payment_1) || 0;
        newState.net_amount = String(parseInt(total_amount) - pay0 - pay1); 
        newState.other_amount = String(parseInt(other_amount));;
        newState.lc_charge = String(parseInt(lc_charge));

        // if(process.env.REACT_APP_CLIENT == "xpress"){
        //     let total_amount = 0;
        //     let our_freight = 0;
        //     for (let i = 0; i < newState.bilty_ids.length; i++) {
        //         const biltyObj = newState.bilty_ids[i];
        //         if (biltyObj.checked == "1") {
        //             our_freight += parseFloat(biltyObj.total_amount) || 0;
        //         }
        //     }
        //     total_amount = our_freight;
        //     newState.total_amount = total_amount;
        // }
        // myForm.setPageStateByField("bilty_ids", dummyArray)
        myForm.setPageState((prevState) => ({
            ...prevState,
            ...newState,
        }));
    };

    useEffect(() => {
        if (!myForm.pageState.total_amount) return;
        if (myForm.pageMode === "write") return;
        const total = parseFloat(myForm.pageState.total_amount) || 0;
        const pay0 = parseFloat(myForm.pageState.payment_0) || 0;
        const pay1 = parseFloat(myForm.pageState.payment_1) || 0;
        const net = String(parseInt(total - pay0 - pay1));
        if (net !== myForm.pageState.net_amount) {
            myForm.setPageStateByField("net_amount", net);
        }
    }, [myForm.pageState.payment_0, myForm.pageState.payment_1, myForm.pageState.total_amount, myForm.pageMode]);

    console.log('sss', myForm.pageState)

    const getSelectAllValue = () => {
        for (let i = 0; i < myForm.pageState.bilty_ids.length; i++) {
            if (myForm.pageState.bilty_ids[i].checked != "1") {
                return false;
            }
        }
        return true;
    };

    const checkVisibilityCondition = (fieldInfo) => {
        if (fieldInfo.name == "edit_button" && myForm.pageMode == "edit") {
            return true;
        } else if (fieldInfo.name == "total_amount") {
            return false;
        } else if (fieldInfo.name == "delete_button") {
            return false;
        } else if (
            fieldInfo.name == "cheque_no" &&
            myForm.pageState.payment_type == "1"
        ) {
            return false;
        } else {
            return true;
        }
    };

    const checkDisabledCondition = (fieldInfo) => {
        if (fieldInfo.name == "consignor_gst") {
            return "disabled";
        } else if (fieldInfo.name == "rto") {
            return "disabled";
        }else if (fieldInfo.name == "bilty_charge") {
            return "disabled";
        }else if (fieldInfo.name == "hamali_charge") {
            return "disabled";
        }else if (fieldInfo.name == "rto_charge") {
            return "disabled";
        }else if (fieldInfo.name == "detention_charge") {
            return "disabled";
        }else if (fieldInfo.name == "advance") {
            return "disabled";
        }else if (fieldInfo.name == "loading_charge") {
            return "disabled";
        }else if (fieldInfo.name == "unloading_charge") {
            return "disabled";
        }else if (fieldInfo.name == "bilty_detention") {
            return "disabled";
        } else if (fieldInfo.name == "detention") {
            return "disabled"
        }else if (fieldInfo.name == "lc_charge") {
            return "disabled";
        }else if (process.env.REACT_APP_CLIENT !== "shubham" && fieldInfo.name == "extra_hamali") {
            return "disabled";
        } else if (fieldInfo.name == "door_del_charge") {
            return "disabled";
        } else if (fieldInfo.name == "other_amount") {
            return "disabled";
        } else if (fieldInfo.name == "gross_amount") {
        } else if (fieldInfo.name == "extra_percentage_amount") {
            return "disabled";
        } else if (fieldInfo.name == "gross_amount") {
            return "disabled";
        } else if (fieldInfo.name == "x") {
            return "disabled";
        } else if (fieldInfo.name == "total_amount") {
            return "disabled";
        } else if (myForm.pageMode == "view") {
            return "disabled";
        } else if (myForm.pageMode == "edit" && fieldInfo.name == "party_name") {
            return "disabled";
        } else if (myForm.pageMode == "edit" && fieldInfo.name == "input_date") {
            // return "disabled";
        } else {
            return "";
        }
    };

    // const handleDelete = async () => {
    //   const url =
    //     SERVER_URL + "/challan/?booking_chalan_no=" + myForm.pageState.challan_no;
    //   const response = await fetch(url, { method: "DELETE" });
    //   if (!response.ok) {
    //     console.log("Not able to delete challan");
    //     return;
    //   }
    //   const temp_response = await response.json();
    //   if (temp_response.is_deleted) {
    //     myForm.setPageState({ ...challanDataObject, ...variablesFromSession });
    //     myForm.setPageMode("write");
    //     window.location.reload();
    //     return;
    //   }
    // };

    const getAdditionalInfoForSuggestionFetch = (fieldInfoObject) => {
        // if (fieldInfoObject.name == "vehicle_no"){
        //   return {"limit": "10"};
        // }
        if (fieldInfoObject.name == "consignor_name") {
            additionalInfoObject.is_account_related = "1";
            // additionalInfoObject.pay_type = myForm.pageState.pay_type;
            return additionalInfoObject;
        }
        if (fieldInfoObject.name == "vehicle_no") {
            additionalInfoObject.is_active = "1";
            return additionalInfoObject;
        }
        return null;
    };

    const deleteEntryFromTableCallback = (infoObject) => {
        console.log("Info objecyt", infoObject);
        let biltyObj = myForm.pageState.bilty_ids[infoObject.idx];
        console.log("Bilty objecy", biltyObj);
        let newState = {};
        let tran_freight = parseFloat(myForm.pageState.transporter_freight) || 0;
        let our_freight = parseFloat(myForm.pageState.our_freight) || 0;
        let to_pay = parseFloat(myForm.pageState.to_pay) || 0;
        let paid = parseFloat(myForm.pageState.paid) || 0;
        let pkgs = parseFloat(myForm.pageState.pkgs) || 0;

        tran_freight -= parseFloat(biltyObj.transporter_freight) || 0;
        our_freight -= parseFloat(biltyObj.total_amount) || 0;
        if (biltyObj.pay_type == "1") {
            to_pay -= parseFloat(biltyObj.transporter_freight) || 0;
        } else {
            paid -= parseFloat(biltyObj.transporter_freight) || 0;
        }
        pkgs -= parseFloat(biltyObj.no_of_package) || 0;

        newState.transporter_freight = String(tran_freight);
        newState.our_freight = String(our_freight);
        newState.pkgs = String(pkgs);
        newState.to_pay = String(to_pay);
        newState.paid = String(paid);
        newState.balance = String(our_freight - to_pay);
        newState.bilty_ids = infoObject.rows;

        console.log("New state", newState);
        myForm.setPageState({
            ...myForm.pageState,
            ...newState,
        });
    };

    const handleSendEmail = async () => {

        let ccEmails = myForm.pageState.cc_emails;
        ccEmails = ccEmails.split("\n").join(",");
        // console.log(ccEmails);

        myForm.setOverlay(true);

        const mailBody = myForm.pageState.body_start + "|" + myForm.pageState.body_end;

        const dataToSend = {
            tbb_statement_id: myForm.pageState.bill_no,
            branch_id: sessionObject.sessionVariables.branch_id,
            receiver_mail: myForm.pageState.email,
            subject: myForm.pageState.subject,
            cc: ccEmails,
            user_id: sessionObject.sessionVariables.user_id,
            body: mailBody,
            fyear: myForm.pageState.fYear_get,
            companyId: myForm.pageState.company_id,
        }

        const url = SERVER_URL + "/tbb_billing_statement/send_bill_mail";

        const resp = await fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify(dataToSend),
        })

        myForm.setOverlay(false);

        if (resp.ok) {
            const data = await resp.json();
            console.log({ data });
            setMailStatus(data.message);
        }
        else {
            setMailStatus("Something went wrong while sending an Email ):")
        }

    }

    let ccEmailFieldInfo = {
        // display
        label: "CC",

        // styling
        className: "form-row",
        labelClassName: "form-label",
        inputClassName: "form-input",

        // dataobject name
        name: "cc_email",

        // type
        type: "text",
        placeHolder: "",

        // when selected some suggestion
        // apiConfigKey: "getConsigneeSuggestions",

        // suggesion api
        url: SERVER_URL + "/mail/",

        // from resp of suggestion api, which field to show
        suggestionKeyword: "email",

        // along with suggesions, which field to show
        suggestionKeywordExtra: "company_id",

        // typed text in api, based on which results come
        suggestionKeywordForFetchApiArgs: "email",

        // when some suggestion is chosen, by which field that suggestion to fetch
        // suggestionChooseQueryKeyword: "id",

        /**
         * If api call not required,
         * parse suggestion schema here only and update the page state.
         */
        suggestionSchema: {
            email: "cc_email"
        },

        // apiCallRequiredOnGetValue: true,
        toValidate: true,
        // regExpValidation: "[a-zA-z]",
        // keyboardNavigationMap: {
        //     conditionalNav: true,
        //     conditionalNavFunct: (pageState) => {
        //         if (pageState.voucher_type == "cp") {
        //             return "amount";
        //         }
        //         else if (pageState.voucher_type == "bp") {
        //             return "id";
        //         }
        //         else if (pageState.voucher_type == "cr") {
        //             return "amount";
        //         }
        //         else if (pageState.voucher_type == "jv") {
        //             return "amount";
        //         }
        //         else if (pageState.voucher_type == "br") {
        //             return "amount";
        //         }
        //         else {
        //             return "consignee_name";
        //         }
        //     },
        // },
        // idClearanceNeeded: "consignee_id",
        // inputDataNeededInSuggestions: false,
        // inputDataFilter: {
        //     pay_type: "same",
        // },
    };

    return (
        <div className="mr-form-container">
            {USE_OVERLAY && (
                <LoadingOverlay
                    active={myForm.overlay}
                    spinner
                    text="Loading your content..."
                    styles={{
                        wrapper: {
                            // width: '400px',
                            // height: '400px',
                            overflow: true ? "hidden" : "scroll",
                        },
                    }}
                ></LoadingOverlay>
            )}
            <div>
                <Popup
                    // trigger={<button className="button"> Open Modal </button>}
                    open={myForm.pageMode == "submitted" || myForm.pageMode == "error"}
                    modal
                    contentStyle={contentStyle}
                    closeOnDocumentClick={false}
                >
                    {(close) => (
                        <div className="pop-up-container">
                            <div className="pop-up-header">
                                {" "}
                                {myForm.pageMode == "submitted" ? (
                                    <div>{popupInfo.success_header}</div>
                                ) : (
                                    <div>{popupInfo.error_header}</div>
                                )}
                                <div>
                                    <a className="pop-up-close btn" onClick={close}>
                                        &times;
                                    </a>
                                </div>
                            </div>
                            {myForm.pageMode == "submitted" ? (
                                <div className="pop-up-content">
                                    {popupInfo.success_title}
                                    <br />
                                    <div className="pop-up-fields">
                                        <div className="pop-up-field">
                                            <div className="pop-up-field-label">
                                                {popupInfo.field_label_success}
                                            </div>
                                            <div className="pop-up-field-value">
                                                {myForm.pageState[popupInfo.field_name_success]}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div className="pop-up-content">
                                    {popupInfo.error_title}
                                    <br />
                                    <div className="pop-up-fields">
                                        <div className="pop-up-field">
                                            <div className="pop-up-field-label">
                                                {popupInfo.field_label_error}
                                            </div>
                                            <div className="pop-up-field-value">
                                                {myForm.popupError}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                            <div className="pop-up-actions">
                                <button
                                    className="pop-up-button"
                                    onClick={() => {
                                        if (myForm.pageMode == "submitted") {
                                            // sessionObject.saveSessionVariableByField("last_bilty_no", {"last_bilty_no":myForm.pageState.bilty_no})
                                            myForm.setPageState({
                                                ...dataObject,
                                                ...variablesFromSession,
                                            });
                                            myForm.setPageMode("write");
                                            window.location.reload();
                                            close();
                                        } else {
                                            myForm.setPageMode("write");
                                            close();
                                        }
                                    }}
                                >
                                    Okay
                                </button>
                            </div>
                        </div>
                    )}
                </Popup>
            </div>
            <div>
                <Popup
                    open={myForm.pageState.send_email == true}
                    modal
                    contentStyle={contentStyle}
                    closeOnDocumentClick={false}
                >
                    {(close) => {
                        return (
                            <div className="pop-up-container">
                                <div className="pop-up-header">
                                    Send Email
                                    <div>
                                        <a className="pop-up-close btn" onClick={() => {
                                            myForm.setPageState((pageState) => ({
                                                ...pageState,
                                                "send_email": false,
                                                "email": "",
                                                "subject": "",
                                                "cc_email": "",
                                                "cc_emails": "",
                                            }))
                                            close();
                                        }}>
                                            &times;
                                        </a>
                                    </div>
                                </div>
                                <div className="popup-content">
                                    <div className="pop-up-fields">
                                        <div className="pop-up-field">
                                            <label className="form-label">From </label>
                                            <input
                                                className="form-input"
                                                type="email"
                                                name="email_from"
                                                value={myForm.pageState.email_from}
                                                disabled={true}
                                            />

                                        </div>
                                        <div className="pop-up-field">
                                            <label className="form-label">To </label>
                                            <input
                                                className="form-input"
                                                type="email"
                                                name="email"
                                                value={myForm.pageState.email}
                                                onChange={myForm.handleChange}
                                                onKeyPress={(e) => {
                                                    if (e.key == "Enter") {
                                                        document.getElementById("cc_email").focus();
                                                    }
                                                }}
                                                autoFocus={true}
                                            />

                                        </div>
                                        <div className="pop-up-field">
                                            <label className="form-label">CC </label>
                                            {/* <input
                                                className="form-input"
                                                type="email"
                                                name="cc_email"
                                                id="cc_email"
                                                value={myForm.pageState.cc_email}
                                                onChange={myForm.handleChange}
                                                onKeyPress={(e) => {
                                                    if (e.key == "Enter") {
                                                        let ccEmail = myForm.pageState.cc_email;
                                                        let ccEmails = myForm.pageState.cc_emails;
                                                        if (ccEmail.length > 0) {
                                                            ccEmails += ccEmail + "\n";
                                                        }

                                                        myForm.setPageState({
                                                            ...myForm.pageState,
                                                            "cc_email": "",
                                                            "cc_emails": ccEmails,
                                                        })
                                                        document.getElementById("subject").focus();
                                                    }
                                                }}
                                            /> */}
                                            <Autosuggest
                                                // suggestions={myForm.suggestions}
                                                suggestions = {(myForm.suggestions != undefined) ? myForm.suggestions : ""}  // changes made for removing error that was caused by undefined suggestion
                                                onSuggestionsFetchRequested={(a) =>
                                                    myForm.onSuggestionsFetchRequestedDebounced(
                                                        a,
                                                        (b) =>
                                                            myForm.suggestionFetchApi(
                                                                ccEmailFieldInfo,
                                                                b
                                                            )
                                                    )
                                                }
                                                onSuggestionsClearRequested={() =>
                                                    myForm.onSuggestionsClearRequested(ccEmailFieldInfo)
                                                }
                                                getSuggestionValue={(suggestion) =>
                                                    suggestion[ccEmailFieldInfo.suggestionKeyword]
                                                }
                                                onSuggestionSelected={(a, b) =>
                                                    myForm.getSuggestionValue(
                                                        b.suggestion,
                                                        ccEmailFieldInfo,
                                                        myForm.performSuggestions,
                                                        myForm.updatePageStateForGetSuggestion
                                                    )
                                                }
                                                renderSuggestion={(a) =>
                                                    myForm.renderSuggestion(a, ccEmailFieldInfo)
                                                }
                                                highlightFirstSuggestion={true}
                                                ref={(a) => myForm.storeInputReference(a, false)}
                                                inputProps={{
                                                    id: "cc_email",
                                                    // placeholder: ccEmailFieldInfo["placeholder"],
                                                    value: String(
                                                        myForm.pageState[ccEmailFieldInfo["name"]]
                                                    ),
                                                    onChange: (a, b) => {
                                                        myForm.onChangeAutoSuggest(a, b, ccEmailFieldInfo);
                                                    },
                                                    onBlur: () => {
                                                        ccEmailFieldInfo["toValidate"]
                                                            ? myForm.onblurValidator(ccEmailFieldInfo)
                                                            : {};
                                                    },
                                                    onKeyPress: (e) => {
                                                        if (e.key == "Enter") {
                                                            let ccEmail = myForm.pageState.cc_email;
                                                            let ccEmails = myForm.pageState.cc_emails;
                                                            if (ccEmails.length > 0) {
                                                                ccEmails += "\n";
                                                            }
                                                            ccEmails += ccEmail;

                                                            myForm.setPageState({
                                                                ...myForm.pageState,
                                                                "cc_email": "",
                                                                "cc_emails": ccEmails,
                                                            })
                                                            document.getElementById("subject").focus();
                                                        }
                                                    }
                                                }}
                                            />
                                        </div>
                                        <div className="pop-up-field">
                                            <label className="form-label">Final CC </label>
                                            <textarea
                                                className="form-input"
                                                type="textbox"
                                                name="cc_emails"
                                                id="cc_emails"
                                                disabled
                                                value={myForm.pageState.cc_emails}
                                                style={{
                                                    color: "grey",
                                                    overflow: "auto",
                                                    height: "70px",
                                                    resize: "none"
                                                }}
                                            />
                                        </div>
                                        <div className="pop-up-field">
                                            <label className="form-label">Subject </label>
                                            <input
                                                className="form-input"
                                                type="text"
                                                name="subject"
                                                id="subject"
                                                value={myForm.pageState.subject}
                                                onChange={myForm.handleChange}
                                                onKeyPress={(e) => {
                                                    if (e.key == "Enter") {
                                                        e.preventDefault();
                                                        document.getElementById("body_start").focus();
                                                    }
                                                }}
                                            />
                                        </div>
                                        <div className="pop-up-field">
                                            <label className="form-label">Body Start </label>
                                            <textarea
                                                className="form-input"
                                                type="text"
                                                name="body_start"
                                                id="body_start"
                                                style={{height: "50px"}}
                                                value={myForm.pageState.body_start}
                                                onChange={myForm.handleChange}
                                                // onKeyPress={(e) => {
                                                //     if (e.key == "Enter") {
                                                //         e.preventDefault();
                                                //         document.getElementById("body_end").focus();
                                                //     }
                                                // }}
                                            />
                                        </div>
                                        <div className="pop-up-field">
                                            <label className="form-label">Body End </label>
                                            <textarea
                                                className="form-input"
                                                type="text"
                                                name="body_end"
                                                id="body_end"
                                                style={{height: "50px"}}
                                                value={myForm.pageState.body_end}
                                                onChange={myForm.handleChange}
                                                // onKeyPress={(e) => {
                                                //     if (e.key == "Enter") {
                                                //         e.preventDefault();
                                                //         document.getElementById("send").focus();
                                                //     }
                                                // }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="pop-up-actions">
                                    <button
                                        className="pop-up-button"
                                        id="send"
                                        type="submit"
                                        onClick={() => {
                                            handleSendEmail();
                                            myForm.setPageState((pageState) => ({
                                                ...pageState,
                                                "send_email": false,
                                                "email": "",
                                                "subject": "",
                                                "cc_email": "",
                                                "cc_emails": "",
                                            }))
                                            close();
                                        }}
                                    >
                                        Send
                                    </button>
                                </div>
                            </div>
                        );
                    }}
                </Popup>
            </div>
            <div>
                <Popup
                    open={mailStatus != ""}
                    modal
                    contentStyle={contentStyle}
                    closeOnDocumentClick={false}
                >
                    {(close) => {
                        return (
                            <div className="pop-up-container">
                                <div className="pop-up-header">
                                    Status of Email
                                    <div>
                                        <a className="pop-up-close btn" onClick={() => {
                                            setMailStatus("");
                                            close();
                                        }}>
                                            &times;
                                        </a>
                                    </div>
                                </div>
                                <div className="popup-content">
                                    <div className="pop-up-fields">
                                        <div className="pop-up-field">
                                            <label className="">Message : </label>
                                            <div className="">
                                                {mailStatus}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="pop-up-actions">
                                    <button
                                        className="pop-up-button"
                                        onClick={() => {
                                            setMailStatus("");
                                            close();
                                        }}
                                    >
                                        Okay
                                    </button>
                                </div>
                            </div>
                        );
                    }}
                </Popup>
            </div>
            <div>
                <Popup
                    open={updateStatus != ""}
                    modal
                    contentStyle={contentStyle}
                    closeOnDocumentClick={false}
                >
                    {(close) => {
                        return (
                            <div className="pop-up-container">
                                <div className="pop-up-header">
                                    Status of Update
                                    <div>
                                        <a className="pop-up-close btn" onClick={() => {
                                            setUpdateStatus("");
                                            close();
                                        }}>
                                            &times;
                                        </a>
                                    </div>
                                </div>
                                <div className="popup-content">
                                    <div className="pop-up-fields">
                                        <div className="pop-up-field">
                                            <label className="">Message : </label>
                                            <div className="">
                                                {updateStatus}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="pop-up-actions">
                                    <button
                                        className="pop-up-button"
                                        onClick={() => {
                                            setUpdateStatus("");
                                            close();
                                        }}
                                    >
                                        Okay
                                    </button>
                                </div>
                            </div>
                        );
                    }}
                </Popup>
            </div>
            <div>
                <Popup
                    // trigger={<button className="button"> Open Modal </button>}
                    open={myForm.deletePopup}
                    modal
                    contentStyle={contentStyle}
                    closeOnDocumentClick={false}
                >
                    {(close) => (
                        <div className="pop-up-container">
                            <div className="pop-up-header">Are you sure want to delete?</div>
                            <div className="pop-up-actions">
                                <button
                                    className="pop-up-button"
                                    onClick={() => {
                                        handleDelete();
                                        myForm.setDeletePopup(false);
                                        close();
                                    }}
                                >
                                    Yes
                                </button>
                                <button
                                    className="pop-up-button"
                                    onClick={() => {
                                        myForm.setDeletePopup(false);
                                        close();
                                    }}
                                >
                                    No
                                </button>
                            </div>
                        </div>
                    )}
                </Popup>
            </div>
            <div className="form-header">
            {["mimansha", "rtc", "bl", "TRL", "ttw", "te"].includes(process.env.REACT_APP_CLIENT)
                ? "Party Billing"
                : isPodBilling
                ? "Consignor POD Billing"
                : "Consignor Billing"}
            </div>
            <div className="form">
                <div className="form-title">
                    <div className="form-row">
                        <label className="form-label">
                            {["mimansha", "rtc", "bl", "TRL", "ttw", "te"].includes(process.env.REACT_APP_CLIENT)
                                ? "Party Billing No:"
                                : "Consignor Billing No:"}
                        </label>
                        <input
                            className="form-input"
                            type="text"
                            name="bill_no"
                            placeholder=""
                            value={myForm.pageState.bill_no}
                            onChange={myForm.handleChange}
                            onBlur={() => { }}
                            onKeyPress={(a) =>
                                myForm.getPageOnKeyEnter(a, myForm.pageState.bill_no)
                            }
                            ref={(a) => myForm.storeInputReferenceForSelect(a, "bill_no")}
                            disabled={myForm.pageMode == "view" ? "disabled" : ""}
                        />
                        {myForm.internalValidationErrors["challan_no"] && (
                            <p>{myForm.internalValidationErrors["challan_no"]}</p>
                        )}
                        {myForm.pageMode == "view" && (
                            <>
                                {checkVisibilityCondition({ name: "edit_button" }) && (
                                    <button
                                        onClick={() => {
                                            myForm.setPageMode("edit");
                                        }}
                                    >
                                        Edit
                                    </button>
                                )}
                                {/* <button onClick={handleDelete}>Delete</button> */}
                            </>
                        )}
                        {["TRL", "ttw", "te"].includes(process.env.REACT_APP_CLIENT) &&
                            String(sessionObject.sessionVariables.role_id) === "1" && (
                            <EditHistoryPopup
                                moduleName="bill"
                                recordIds={[myForm.pageState.id]}
                            />
                        )}
                    </div>
                    {!["mimansha", "rtc", "bl", "TRL", "ttw", "te"].includes(process.env.REACT_APP_CLIENT) && (
                        <div className="form-row">
                            <label className="form-label">{"Amount >="}</label>
                            <input
                            className="form-input"
                            type="text"
                            name="amount"
                            placeholder=""
                            value={myForm.pageState.amount}
                            onChange={myForm.handleChange}
                            onBlur={() => {}}
                            onKeyPress={(a) => {
                                if (a.key === "Enter") {
                                myForm.makeFocusOnParticularField("input_date");
                                }
                            }}
                            ref={(a) => myForm.storeInputReferenceForSelect(a, "amount")}
                            disabled={myForm.pageMode === "view" ? "disabled" : ""}
                            />
                        </div>
                    )}
                    <div className="form-row-m">
                        <label className="form-label">Bilty Date To:</label>
                        <input
                            className="form-input-mr-statement-date"
                            type="date"
                            name="input_date"
                            placeholder=""
                            value={myForm.pageState.input_date}
                            onChange={myForm.handleChange}
                            ref={(a) => myForm.storeInputReferenceForSelect(a, "input_date")}
                            disabled={checkDisabledCondition({ name: "input_date" })}
                            onKeyPress={(a) => {
                                console.log("Here");
                                if (a.key == "Enter") {
                                    myForm.makeFocusOnParticularField(
                                        ["TRL", "ttw", "te"].includes(process.env.REACT_APP_CLIENT)
                                            ? "vehicle_no"
                                            : "consignor_name",
                                    );
                                }
                            }}
                        />
                    </div>

                    {["TRL", "ttw", "te"].includes(process.env.REACT_APP_CLIENT) && (
                        <div className="form-row">
                            <label className="form-label">Vehicle No.</label>
                            <Autosuggest
                                id={tirupatiVehicleFieldInfo.name}
                                suggestions={(myForm.suggestions != undefined) ? myForm.suggestions : ""}
                                onSuggestionsFetchRequested={(a) =>
                                    myForm.onSuggestionsFetchRequested(a, (b) =>
                                        myForm.suggestionFetchApi(tirupatiVehicleFieldInfo, b)
                                    )
                                }
                                onSuggestionsClearRequested={() =>
                                    myForm.onSuggestionsClearRequested(tirupatiVehicleFieldInfo)
                                }
                                getSuggestionValue={(suggestion) =>
                                    suggestion[tirupatiVehicleFieldInfo.suggestionKeyword]
                                }
                                onSuggestionSelected={(a, b) =>
                                    myForm.getSuggestionValue(
                                        b.suggestion,
                                        tirupatiVehicleFieldInfo,
                                        myForm.performSuggestions,
                                        myForm.updatePageStateForGetSuggestion
                                    )
                                }
                                renderSuggestion={(a) =>
                                    myForm.renderSuggestion(a, tirupatiVehicleFieldInfo)
                                }
                                highlightFirstSuggestion={true}
                                ref={(a) => myForm.storeInputReference(a, false)}
                                inputProps={{
                                    name: tirupatiVehicleFieldInfo.name,
                                    value: String(myForm.pageState[tirupatiVehicleFieldInfo.name] || ""),
                                    onChange: (a, b) => {
                                        myForm.onChangeAutoSuggest(a, b, tirupatiVehicleFieldInfo);
                                    },
                                    onBlur: () => {},
                                    onKeyPress: linkBilty,
                                    disabled: checkDisabledCondition(tirupatiVehicleFieldInfo),
                                }}
                            />
                        </div>
                    )}

                    <div className="form-row">
                        <label className="form-label">Billing Party</label>
                        <Autosuggest
                            id={transporterFieldInfo["name"]}
                            suggestions={(myForm.suggestions != undefined) ? myForm.suggestions : ""}
                            onSuggestionsFetchRequested={(a) =>
                                myForm.onSuggestionsFetchRequested(a, (b) =>
                                    myForm.suggestionFetchApi(transporterFieldInfo, b)
                                )
                            }
                            onSuggestionsClearRequested={() =>
                                myForm.onSuggestionsClearRequested(transporterFieldInfo)
                            }
                            getSuggestionValue={(suggestion) =>
                                suggestion[transporterFieldInfo.suggestionKeyword]
                            }
                            onSuggestionSelected={(a, b) =>
                                myForm.getSuggestionValue(
                                    b.suggestion,
                                    transporterFieldInfo,
                                    myForm.performSuggestions,
                                    myForm.updatePageStateForGetSuggestion
                                )
                            }
                            renderSuggestion={(a) =>
                                myForm.renderSuggestion(a, transporterFieldInfo)
                            }
                            highlightFirstSuggestion={true}
                            ref={(a) => myForm.storeInputReference(a, false)}
                            inputProps={{
                                name: transporterFieldInfo.name,
                                value: String(myForm.pageState[transporterFieldInfo["name"]] || ""),
                                onChange: (a, b) => {
                                    myForm.onChangeAutoSuggest(a, b, transporterFieldInfo);
                                },
                                onBlur: () => {
                                    transporterFieldInfo["toValidate"]
                                        ? myForm.onblurValidator(transporterFieldInfo)
                                        : {};
                                },
                                onKeyPress: linkBilty,
                                disabled: checkDisabledCondition(transporterFieldInfo),
                            }}
                        />
                    </div>
                    <div>
                        <label className="form-label">Bill Date:</label>
                        <input
                            className="form-input-mr-statement-date"
                            type="date"
                            name="bill_date"
                            placeholder=""
                            value={myForm.pageState.bill_date}
                            onChange={myForm.handleChange}
                            ref={(a) => myForm.storeInputReferenceForSelect(a, "bill_date")}
                            disabled={checkDisabledCondition({ name: "bill_date" })}
                            onKeyPress={(a) => {
                                console.log("Here");
                                if (a.key == "Enter") {
                                    myForm.makeFocusOnParticularField("remarks");
                                }
                            }}
                        />
                    </div>
                    <div className="form-row">
                        <label className="form-label">
                            {["mimansha", "rtc", "bl", "TRL", "ttw", "te"].includes(process.env.REACT_APP_CLIENT)
                                ? "Last Party Bill:"
                                : "Last Consignor Bill:"}
                        </label>
                        <label className="form-consignor_bill">
                            {myForm.pageState.last_consignor_bill_no}
                        </label>
                    </div>
                </div>
                <div className="form-title-b">
                    <div className="form-row">
                        <label className="form-label">Remarks</label>
                        <input
                            className="form-input-w"
                            type="text"
                            name="remarks"
                            placeholder=""
                            value={myForm.pageState.remarks}
                            onChange={myForm.handleChange}
                            onBlur={() => { }}
                            onKeyPress={(a) => {
                                console.log("Here");
                                if (a.key == "Enter") {
                                    myForm.makeFocusOnParticularField("description1");
                                }
                            }}
                            ref={(a) => myForm.storeInputReferenceForSelect(a, "remarks")}
                            disabled={myForm.pageMode == "view" ? "disabled" : ""}
                        />
                    </div>
                   
                </div>

                <div className="table-container">
                    <DynamicViewTable
                        checkBox={1}
                        tableHeader={consignorBillingTableHeader}
                        tableItems={consignorBillingTableItems}
                        tableValues={myForm.pageState["bilty_ids"]}
                        setPageStateByField={myForm.setPageStateByField}
                        pageStateArray={myForm.pageState["bilty_ids"]}
                        deleteEntryFromTableCallback={deleteEntryFromTableCallback}
                        handleCheckboxChange={handleCheckboxChange}
                        fieldMapping="bilty_ids"
                        getSelectAllValue={getSelectAllValue}
                        selectAll={selectAll}
                        deselectAll={deselectAll}
                    />
                </div>
                <div className="form-input-c">
                    <div className="form-field-left responsive-table">
                        <div>
                            Amt{" "}
                            <input
                                size="10"
                                name="gross_amount"
                                placeholder=""
                                value={myForm.pageState.gross_amount}
                                onChange={myForm.handleChange}
                                disabled={checkDisabledCondition({ name: "gross_amount" })}
                                onBlur={() => { }}
                                onKeyPress={(a) => {
                                    console.log("Here");
                                    if (a.key == "Enter") {
                                        myForm.makeFocusOnParticularField("door_del_charge");
                                    }
                                }}
                                ref={(a) =>
                                    myForm.storeInputReferenceForSelect(a, "gross_amount")
                                }
                            ></input>
                        </div>
                        <div>
                            <p />
                        </div>

                        <table border="1px">
                            <tr>
                                <th className="bill-input-small"> No.</th>
                                <th className="bill-input-small">Description</th>
                                <th className="bill-input-small">Amt</th>
                            </tr>
                            <tr>
                                <td className="bill-input-small">1</td>
                                <td className="bill-input-small">
                                    <input
                                        className="bill-input-large"
                                        name="description1"
                                        placeholder=""
                                        value={myForm.pageState.description1}
                                        onChange={myForm.handleChange}
                                        disabled={checkDisabledCondition({ name: "description1" })}
                                        onBlur={() => { }}
                                        onKeyPress={(a) => {
                                            console.log("Here");
                                            if (a.key == "Enter") {
                                                myForm.makeFocusOnParticularField("amt1");
                                            }
                                        }}
                                        ref={(a) =>
                                            myForm.storeInputReferenceForSelect(a, "description1")
                                        }
                                    ></input>
                                </td>
                                <td className="bill-input-small">
                                    <input
                                        className="bill-input-small"
                                        name="amt1"
                                        placeholder=""
                                        value={myForm.pageState.amt1}
                                        onChange={myForm.handleChange}
                                        disabled={checkDisabledCondition({ name: "amt1" })}
                                        onBlur={() => { }}
                                        onKeyPress={(a) => {
                                            console.log("Here");
                                            if (a.key == "Enter") {
                                                myForm.makeFocusOnParticularField("description2");
                                            }
                                        }}
                                        ref={(a) => myForm.storeInputReferenceForSelect(a, "amt1")}
                                    ></input>
                                </td>
                            </tr>
                            <tr>
                                <td className="bill-input-small">2</td>
                                <td className="bill-input-small">
                                    <input
                                        className="bill-input-large"
                                        name="description2"
                                        placeholder=""
                                        value={myForm.pageState.description2}
                                        onChange={myForm.handleChange}
                                        disabled={checkDisabledCondition({ name: "description2" })}
                                        onBlur={() => { }}
                                        onKeyPress={(a) => {
                                            console.log("Here");
                                            if (a.key == "Enter") {
                                                myForm.makeFocusOnParticularField("amt2");
                                            }
                                        }}
                                        ref={(a) =>
                                            myForm.storeInputReferenceForSelect(a, "description2")
                                        }
                                    ></input>
                                </td>
                                <td className="bill-input-small">
                                    <input
                                        className="bill-input-small"
                                        name="amt2"
                                        placeholder=""
                                        value={myForm.pageState.amt2}
                                        onChange={myForm.handleChange}
                                        disabled={checkDisabledCondition({ name: "amt2" })}
                                        onBlur={() => { }}
                                        onKeyPress={(a) => {
                                            console.log("Here");
                                            if(process.env.REACT_APP_CLIENT == "shubham") {
                                                if (a.key == "Enter") {
                                                    myForm.makeFocusOnParticularField("description3");
                                                }
                                            }
                                            else {
                                                if (a.key == "Enter") {
                                                    myForm.makeFocusOnParticularField("extra_percentage");
                                                }
                                            }
                                        }}
                                        ref={(a) => myForm.storeInputReferenceForSelect(a, "amt2")}
                                    ></input>
                                </td>
                            </tr>
                            {process.env.REACT_APP_CLIENT == "shubham" &&
                                <tr>
                                <td className="bill-input-small">3</td>
                                <td className="bill-input-small">
                                    <input
                                        className="bill-input-large"
                                        name="description3"
                                        placeholder=""
                                        value={myForm.pageState.description3}
                                        onChange={myForm.handleChange}
                                        disabled={checkDisabledCondition({ name: "description3" })}
                                        onBlur={() => { }}
                                        onKeyPress={(a) => {
                                            console.log("Here");
                                            if (a.key == "Enter") {
                                                myForm.makeFocusOnParticularField("amt3");
                                            }
                                        }}
                                        ref={(a) =>
                                            myForm.storeInputReferenceForSelect(a, "description3")
                                        }
                                    ></input>
                                </td>
                                <td className="bill-input-small">
                                    <input
                                        className="bill-input-small"
                                        name="amt3"
                                        placeholder=""
                                        value={myForm.pageState.amt3}
                                        onChange={myForm.handleChange}
                                        disabled={checkDisabledCondition({ name: "amt3" })}
                                        onBlur={() => { }}
                                        onKeyPress={(a) => {
                                            console.log("Here");
                                            if (a.key == "Enter") {
                                                myForm.makeFocusOnParticularField("extra_hamali");
                                            }
                                        }}
                                        ref={(a) => myForm.storeInputReferenceForSelect(a, "amt3")}
                                    ></input>
                                </td>
                            </tr>
                            }
                        </table>
                        {/* <FormColumn
              groupInfo={groupInfo}
              groupName="group-0"
              checkDisabledCondition={checkDisabledCondition}
              checkVisibilityCondition={checkVisibilityCondition}
              myFormObj={myForm}
              getAdditionalInfoForSuggestionFetch={getAdditionalInfoForSuggestionFetch}
            /> */}
                    </div>
                    <div className="form-field-left">
                        {/* <FormColumn
              groupInfo={groupInfo}
              groupName="group-2"
              checkDisabledCondition={checkDisabledCondition}
              checkVisibilityCondition={checkVisibilityCondition}
              myFormObj={myForm}
              getAdditionalInfoForSuggestionFetch={getAdditionalInfoForSuggestionFetch}
            /> */}
                        {process.env.REACT_APP_CLIENT !== "shubham" && <div className="bill-margin">
                            Extra(%) &nbsp; &nbsp; &nbsp; &nbsp;
                            <input
                                className="extra-input-1"
                                size="3"
                                name="extra_percentage"
                                placeholder=""
                                value={myForm.pageState.extra_percentage}
                                onChange={myForm.handleChange}
                                // disabled={checkDisabledCondition({name:"amt1"})}
                                onBlur={() => { }}
                                onKeyPress={(a) => {
                                    console.log("Here");
                                    if (a.key == "Enter") {
                                        myForm.makeFocusOnParticularField("add");
                                    }
                                }}
                                ref={(a) =>
                                    myForm.storeInputReferenceForSelect(a, "extra_percentage")
                                }
                            />
                            <input
                                className="extra-input-2"
                                size="10"
                                name="extra_percentage_amount"
                                placeholder=""
                                value={myForm.pageState.extra_percentage_amount}
                                onChange={myForm.handleChange}
                                disabled={checkDisabledCondition({
                                    name: "extra_percentage_amount",
                                })}
                                onBlur={() => { }}
                                onKeyPress={(a) => {
                                    console.log("Here");
                                    if (a.key == "Enter") {
                                        myForm.makeFocusOnParticularField("amount");
                                    }
                                }}
                                ref={(a) =>
                                    myForm.storeInputReferenceForSelect(
                                        a,
                                        "extra_percentage_amount"
                                    )
                                }
                            ></input>
                        </div>}
                        <div>
                            <p />
                        </div>
                        {["mk_log", "atc", "mimansha", "rtc", "bl", "TRL", "ttw", "te"].includes(process.env.REACT_APP_CLIENT) ? (
                            <>
                              <div>
                                Bilty charge{" "}
                                <input
                                  size="16"
                                  name="bilty_charge"
                                  placeholder=""
                                  value={myForm.pageState.bilty_charge}
                                  onChange={myForm.handleChange}
                                  disabled={checkDisabledCondition({ name: "bilty_charge" })}
                                  onBlur={() => {}}
                                  onKeyPress={(a) => {
                                    if (a.key === "Enter") {
                                      myForm.makeFocusOnParticularField("rto_charge");
                                    }
                                  }}
                                  ref={(a) => myForm.storeInputReferenceForSelect(a, "hamali_charge")}
                                />
                              </div>
                              <div>
                                Hamali charge{" "}
                                <input
                                  size="16"
                                  name="hamali_charge"
                                  placeholder=""
                                  value={myForm.pageState.hamali_charge}
                                  onChange={myForm.handleChange}
                                  disabled={checkDisabledCondition({ name: "hamali_charge" })}
                                  onBlur={() => {}}
                                  onKeyPress={(a) => {
                                    if (a.key === "Enter") {
                                      myForm.makeFocusOnParticularField("rto_charge");
                                    }
                                  }}
                                  ref={(a) => myForm.storeInputReferenceForSelect(a, "hamali_charge")}
                                />
                              </div>
                            </>
                          ) : (
                            <div>
                                {process.env.REACT_APP_CLIENT === "shubham" ? "Hamali " : "Extra Hamali "}
                                <input
                                size="16"
                                name="extra_hamali"
                                placeholder=""
                                value={myForm.pageState.extra_hamali}
                                onChange={myForm.handleChange}
                                disabled={checkDisabledCondition({ name: "extra_hamali" })}
                                onBlur={() => {}}
                                onKeyPress={(a) => {
                                  if (process.env.REACT_APP_CLIENT === "shubham") {
                                    if (a.key === "Enter") {
                                      myForm.makeFocusOnParticularField("add");
                                    }
                                  } else {
                                    if (a.key === "Enter") {
                                      myForm.makeFocusOnParticularField("door_del_charge");
                                    }
                                  }
                                }}
                                ref={(a) => myForm.storeInputReferenceForSelect(a, "extra_hamali")}
                              />
                            </div>
                          )}

                        {["atc"].includes(process.env.REACT_APP_CLIENT) ? (
                        <div>
                            RTO Charge &nbsp; &nbsp;
                            <input
                            size="16"
                            name="rto_charge"
                            placeholder=""
                            value={myForm.pageState.rto_charge}
                            onChange={myForm.handleChange}
                            disabled={checkDisabledCondition({ name: "rto_charge" })}
                            onBlur={() => {}}
                            onKeyPress={(a) => {
                                if (a.key === "Enter") {
                                myForm.makeFocusOnParticularField("detention_charge");
                                }
                            }}
                            ref={(a) =>
                                myForm.storeInputReferenceForSelect(a, "rto_charge")
                            }
                            />
                        </div>
                        ) : (
                        process.env.REACT_APP_CLIENT !== "shubham" && 
                        process.env.REACT_APP_CLIENT !== "mk_log" &&
                        process.env.REACT_APP_CLIENT !== "xpress" && (
                            <div>
                            DD Charge &nbsp; &nbsp;
                            <input
                                size="16"
                                name="door_del_charge"
                                placeholder=""
                                value={myForm.pageState.door_del_charge}
                                onChange={myForm.handleChange}
                                disabled={checkDisabledCondition({ name: "door_del_charge" })}
                                onBlur={() => {}}
                                onKeyPress={(a) => {
                                if (a.key === "Enter") {
                                    myForm.makeFocusOnParticularField("bilty_charge");
                                }
                                }}
                                ref={(a) =>
                                myForm.storeInputReferenceForSelect(a, "door_del_charge")
                                }
                            />
                            </div>
                        )
                        )}

                        {["atc",].includes(process.env.REACT_APP_CLIENT) ? (
                            <div>
                                Detention Charge &nbsp;
                                <input
                                size="16"
                                name="detention_charge"
                                placeholder=""
                                value={myForm.pageState.detention_charge}
                                onChange={myForm.handleChange}
                                disabled={checkDisabledCondition({ name: "detention_charge" })}
                                onBlur={() => {}}
                                onKeyPress={(a) => {
                                    if (a.key === "Enter") {
                                    myForm.makeFocusOnParticularField("add");
                                    }
                                }}
                                ref={(a) =>
                                    myForm.storeInputReferenceForSelect(a, "detention_charge")
                                }
                                />
                            </div>
                            ) : (
                            process.env.REACT_APP_CLIENT !== "xpress" &&
                            process.env.REACT_APP_CLIENT !== "shubham" &&
                            process.env.REACT_APP_CLIENT !== "mimansha" &&
                            process.env.REACT_APP_CLIENT !== "mk_log" &&
                            process.env.REACT_APP_CLIENT !== "bl" &&
                            process.env.REACT_APP_CLIENT !== "TRL" &&
                            process.env.REACT_APP_CLIENT !== "ttw" &&
                            process.env.REACT_APP_CLIENT !== "te" &&
                            process.env.REACT_APP_CLIENT !== "rtc" && (
                                <div>
                                Bilty Charge &nbsp;
                                <input
                                    size="16"
                                    name="bilty_charge"
                                    placeholder=""
                                    value={myForm.pageState.bilty_charge}
                                    onChange={myForm.handleChange}
                                    disabled={checkDisabledCondition({ name: "bilty_charge" })}
                                    onBlur={() => {}}
                                    onKeyPress={(a) => {
                                    if (a.key === "Enter") {
                                        myForm.makeFocusOnParticularField("add");
                                    }
                                    }}
                                    ref={(a) =>
                                    myForm.storeInputReferenceForSelect(a, "bilty_charge")
                                    }
                                />
                                </div>
                            )
                        )}

                        {["mk_log"].includes(process.env.REACT_APP_CLIENT) && (
                            <div>
                                Detention Charge
                                <input
                                    size="16"
                                    name="detention"
                                    placeholder=""
                                    value={myForm.pageState.detention}
                                    onChange={myForm.handleChange}
                                    disabled={checkDisabledCondition({ name: "detention" })}
                                    onBlur={() => { }}
                                    onKeyPress={(a) => {
                                    if (a.key == "Enter") {
                                        myForm.makeFocusOnParticularField("rto");
                                    }
                                    }}
                                    ref={(a) =>
                                    myForm.storeInputReferenceForSelect(a, "detention")
                                    }
                                ></input>
                            </div>
                        )}

                        {["mimansha", "rtc", "bl", "TRL", "ttw", "te"].includes(process.env.REACT_APP_CLIENT) && (
                            <div>
                                Service Charge
                                <input
                                    size="16"
                                    name="other_amount"
                                    placeholder=""
                                    value={myForm.pageState.other_amount}
                                    onChange={myForm.handleChange}
                                    disabld={checkDisabledCondition({ name: "other_amount" })}
                                    onBlur={() => {}}
                                    onKeyPress={(a) => {
                                        if (a.key === "Enter") {
                                        myForm.makeFocusOnParticularField("add");
                                        }
                                    }}
                                    ref={(a) => myForm.storeInputReferenceForSelect(a, "other_amount")}
                                />
                            </div>
                        )}

                        {(process.env.REACT_APP_CLIENT === "avr" || process.env.REACT_APP_CLIENT === "mimansha" || process.env.REACT_APP_CLIENT === "rtc" || process.env.REACT_APP_CLIENT === "bl" || process.env.REACT_APP_CLIENT === "TRL" || process.env.REACT_APP_CLIENT === "ttw" || process.env.REACT_APP_CLIENT === "te") && (
                            <div>
                                {process.env.REACT_APP_CLIENT === "avr" ? "Collection Charge" : "LC Charge"}
                                <input
                                    size="16"
                                    name="lc_charge"
                                    placeholder=""
                                    value={myForm.pageState.lc_charge}
                                    onChange={myForm.handleChange}
                                    disabled={checkDisabledCondition({ name: "lc_charge" })}
                                    onBlur={() => {}}
                                    onKeyPress={(a) => {
                                        if (a.key === "Enter") {
                                        myForm.makeFocusOnParticularField("add");
                                        }
                                    }}
                                    ref={(a) => myForm.storeInputReferenceForSelect(a, "lc_charge")}
                                />
                            </div>
                        )}
                        {
                            process.env.REACT_APP_CLIENT == "xpress" && <>
                                <div>
                                Loading Charge
                                <input
                                    size="16"
                                    name="loading_charge"
                                    placeholder=""
                                    value={myForm.pageState.loading_charge}
                                    onChange={myForm.handleChange}
                                    disabled={checkDisabledCondition({ name: "loading_charge" })}
                                    onBlur={() => { }}
                                    onKeyPress={(a) => {
                                    if (a.key == "Enter") {
                                        myForm.makeFocusOnParticularField("unloading_charge");
                                    }
                                    }}
                                    ref={(a) =>
                                    myForm.storeInputReferenceForSelect(a, "loading_charge")
                                    }
                                ></input>
                                </div>
                                <div>
                                Unloading Charge
                                <input
                                    size="16"
                                    name="unloading_charge"
                                    placeholder=""
                                    value={myForm.pageState.unloading_charge}
                                    onChange={myForm.handleChange}
                                    disabled={checkDisabledCondition({ name: "unloading_charge" })}
                                    onBlur={() => { }}
                                    onKeyPress={(a) => {
                                    if (a.key == "Enter") {
                                        myForm.makeFocusOnParticularField("bilty_detention");
                                    }
                                    }}
                                    ref={(a) =>
                                    myForm.storeInputReferenceForSelect(a, "unloading_charge")
                                    }
                                ></input>
                                </div>
                                <div>
                                Detention Charge
                                <input
                                    size="16"
                                    name="bilty_detention"
                                    placeholder=""
                                    value={myForm.pageState.bilty_detention}
                                    onChange={myForm.handleChange}
                                    disabled={checkDisabledCondition({ name: "bilty_detention" })}
                                    onBlur={() => { }}
                                    onKeyPress={(a) => {
                                    if (a.key == "Enter") {
                                        myForm.makeFocusOnParticularField("rto");
                                    }
                                    }}
                                    ref={(a) =>
                                    myForm.storeInputReferenceForSelect(a, "bilty_detention")
                                    }
                                ></input>
                                </div>
                                <div>
                                RTO Charge &nbsp; &nbsp;
                                <input
                                    size="16"
                                    name="rto"
                                    placeholder=""
                                    value={myForm.pageState.rto}
                                    onChange={myForm.handleChange}
                                    disabled={checkDisabledCondition({ name: "rto" })}
                                    onBlur={() => { }}
                                    onKeyPress={(a) => {
                                        console.log("Here");
                                        if (a.key == "Enter") {
                                            myForm.makeFocusOnParticularField("advance");
                                        }
                                    }}
                                    ref={(a) =>
                                        myForm.storeInputReferenceForSelect(a, "rto")
                                    }
                                ></input>
                                </div>
                                <div>
                                Advance &nbsp; &nbsp;
                                <input
                                    size="16"
                                    name="advance"
                                    placeholder=""
                                    value={myForm.pageState.advance}
                                    onChange={myForm.handleChange}
                                    disabled={checkDisabledCondition({ name: "advance" })}
                                    onBlur={() => { }}
                                    onKeyPress={(a) => {
                                        console.log("Here");
                                        if (a.key == "Enter") {
                                            myForm.makeFocusOnParticularField("add");
                                        }
                                    }}
                                    ref={(a) =>
                                        myForm.storeInputReferenceForSelect(a, "advance")
                                    }
                                ></input>
                                </div>
                            </>
                        }
                    </div>
                    <div className="form-field-left">
                        <FormColumn
                            groupInfo={groupInfo}
                            groupName="group-1"
                            checkDisabledCondition={checkDisabledCondition}
                            checkVisibilityCondition={checkVisibilityCondition}
                            myFormObj={myForm}
                            getAdditionalInfoForSuggestionFetch={
                                getAdditionalInfoForSuggestionFetch
                            }
                        />
                    </div>
                </div>

                {myForm.pageMode == "edit" && <div className="form-title-b">      
                    <div className="form-row-m"  style={{paddingTop: "10px"}}>
                            <label className="form-label">Date From:</label>
                            <input
                                className="form-input-mr-statement-date"
                                type="date"
                                name="update_date_from"
                                placeholder=""
                                value={myForm.pageState.update_date_from}
                                onChange={myForm.handleChange}
                                ref={(a) => myForm.storeInputReferenceForSelect(a, "update_date_from")}
                                disabled={checkDisabledCondition({ name: "update_date_from" })}
                                onKeyPress={(a) => {
                                    console.log("Here");
                                    if (a.key == "Enter") {
                                        myForm.makeFocusOnParticularField("update_date_to");
                                    }
                                }}
                            />
                    </div>
                    <div className="form-row-m"  style={{paddingTop: "10px"}}>
                        <label className="form-label">Date To:</label>
                        <input
                            className="form-input-mr-statement-date"
                            type="date"
                            name="update_date_to"
                            placeholder=""
                            value={myForm.pageState.update_date_to}
                            onChange={myForm.handleChange}
                            ref={(a) => myForm.storeInputReferenceForSelect(a, "update_date_to")}
                            disabled={checkDisabledCondition({ name: "update_date_to" })}
                            onKeyPress={(a) => {
                                console.log("Here");
                                if (a.key == "Enter") {
                                    myForm.makeFocusOnParticularField("update_button");
                                }
                            }}
                        />
                    </div>
                    <button
                        onClick={updateBiltyRate}
                        type="button"
                        style={{marginTop: "1px" }}
                        // className="btn btn-primary"
                        ref={(a) => myForm.storeInputReferenceForSelect(a, "update_button")}
                    >
                        Update
                    </button>
                    
                </div>}

                <div className="form-footer">
                    <button style={{ display: "none" }}>
                        <ReactHTMLTableToExcel
                            id="test-table-xls-button"
                            className="download-table-xls-button"
                            table="bilty_report_excel"
                            filename="tablexls"
                            sheet="tablexls"
                            buttonText="Download as XLS"
                            ref={(a) => (download_ref.current = a)}
                        />
                    </button>
                    <button
                        className="download-table-xls-button"
                        onClick={async () => {
                            download_ref.current.handleDownload();
                        }}
                    >
                        Download as XLS
                    </button>
                    {ReportExcel.excel_party_bill(myForm.pageState)}

                    {checkVisibilityCondition({ name: "print_button" }) && (
                        <button
                            onClick={(e) => {
                                if (myForm.pageState.edit_bill == "0") {
                                    handlePrint()
                                    return;
                                }
                                myForm.setOverlay(true);
                                myForm.setServerPrintNeeded(true);
                                myForm.handleSubmit(e);
                            }}
                            type="button"
                            className="btn btn-primary"
                            ref={(a) =>
                                myForm.storeInputReferenceForSelect(a, "print_button")
                            }
                        >
                            Print
                        </button>
                    )}
                    <button
                        onClick={(e) => {
                            myForm.handleSubmit(e)
                            myForm.setOverlay(true);
                                }
                            }
                        type="button"
                        className="btn btn-primary"
                        ref={(a) => myForm.storeInputReferenceForSelect(a, "save_button")}
                    >
                        Save
                    </button>
                    <button onClick={() => myForm.setDeletePopup(true)} className="btn btn-primary">Delete</button>
                    <button
                        onClick={() => {
                            myForm.setPageState({
                                ...dataObject,
                                ...variablesFromSession,
                            });
                            window.location.reload();
                            myForm.setPageMode("write");
                        }}
                        className="btn btn-primary"
                    >
                        New
                    </button>
                    
                    {myForm.pageState.bilty_ids.length > 0 &&
                        <button onClick={async () => {

                            const url = SERVER_URL
                                + `/mail/${myForm.pageState.consignor_id}`
                                + `?user_id=${sessionObject.sessionVariables.user_id}`
                                // + "&fyear=" + myForm.pageState.fYear 
                                + "&companyId=" + myForm.pageState.company_id;

                            const resp = await fetch(url);
                            let finalCC = "", finalTo = "", finalFrom = "", subject = "", body_start = "", body_end = "";
                            if (resp.ok) {
                                // console.log("inside");
                                const data = await resp.json();
                                
                                subject = data.subject;
                                body_start = data.body_start;
                                body_end = data.body_end;

                                console.log({ data });

                                if(data.flag == 1) {
                                    finalTo = data.to ?? "";
                                    finalFrom = data.sender ?? "";
    
                                    const cc = data.cc;
                                    cc.forEach(mail => {
                                        if (finalCC.length > 0) finalCC += "\n";
                                        finalCC += mail;
                                    })

                                }
                                // console.log("bar");
                            }

                            // console.log("setting data");
                            myForm.setPageState({
                                ...myForm.pageState,
                                send_email: true,
                                email: finalTo,
                                cc_emails: finalCC,
                                email_from: finalFrom,
                                subject: subject,
                                body_end: body_end,
                                body_start: body_start
                            })
                        }
                        
                        }
                        className="btn btn-primary"
                        >
                            Send Email
                        </button>}
                </div>
            </div>
        </div>
    );
};

export default ConsignorBillingForm;
